import { resetApiState } from 'services';
import { disconnectEcho } from 'services/realtime/echo';
import { onLoggedOut } from 'store/slices/authSlice';

export default function performClientLogout(dispatch) {
  disconnectEcho();
  dispatch(onLoggedOut());
  resetApiState(dispatch);
}
